function _document() {
    return document;
}
var DocumentRef = /** @class */ (function () {
    function DocumentRef() {
    }
    Object.defineProperty(DocumentRef.prototype, "nativeDocument", {
        get: function () {
            return _document();
        },
        enumerable: true,
        configurable: true
    });
    return DocumentRef;
}());
export { DocumentRef };
